export type TenantLocation = {
  id: number;
  tenantId: number;
  type: TenantLocationType
  active: boolean;
  address1: string;
  address2: string;
  county: string;
  city: string;
  stateCode: string;
  zip: string;
  countryCode: string;
  latitude: number;
  longitude: number;
}

export enum TenantLocationType {
  Shop = 0,
  Office = 1,
}

export type CreateUpdateTenantLocationRequest = {
  type: TenantLocationType;
  active: boolean;
  address1: string;
  address2: string | null;
  county: string;
  city: string;
  stateCode: string;
  zip: string;
  countryCode: string;
  latitude: number;
  longitude: number;
}